<div class="p-header">
  <fibr-horizontalmenu
    [items]="items"
    [srcImg]="srcImg"
    [userProfilePath]="userProfilePath"
    [aksesFrom]="aksesFrom"
  ></fibr-horizontalmenu>
</div>
